module.exports = __webpack_public_path__ + "assets/img/icn_a2b_map_marker.svg";